import CheckboxImplementation from './implementation/CheckboxImplementation';
var CheckboxComponent = CheckboxImplementation;
export default CheckboxComponent;
//# sourceMappingURL=CheckboxComponent.js.map